import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 9081982B-5EB6-47C1-A1F3-A83A0ED1B609
 * name glass-mug
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/glass-mug.svg
 * tags
 * - Food / Drink 
 */
export const GlassMugIcon = createSvgIcon(<><path d="M10,4V7H18V4H10M8,2H20L21,2V3L20,4V20L21,21V22H20L8,22H7V21L8,20V18.6L4.2,16.83C3.5,16.5 3,15.82 3,15V8A2,2 0 0,1 5,6H8V4L7,3V2H8M5,15L8,16.39V8H5V15Z" /></>, 'GlassMugIcon');
export default GlassMugIcon